/**
 * 說明 : 大樓資料與後端API調用的非同步行為
 */
import {createAsyncThunk} from '@reduxjs/toolkit';

import BaseAPI from './BaseAPI';

// 新增大樓
export const addBuilding = createAsyncThunk(
  'building/addBuilding',
  async (building, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.postWithAuth('/setting/building', building, token);
      return data;
    } catch (err) {
      console.error('add building error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);

// 修改大樓
export const editBuilding = createAsyncThunk(
  'building/editBuilding',
  async (building, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.putWithAuth('/setting/building', building, token);
      return data;
    } catch (err) {
      console.error('edit building error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);

// 修改大樓狀態
export const editBuildingStatus = createAsyncThunk(
  'building/editBuildingStatus',
  async ({buildingIds, status}, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.putWithAuth('/setting/building/status', {buildingIds: buildingIds, flgStatus: status}, token);
      return data;
    } catch (err) {
      console.error('update building status error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);

// 取得單筆大樓資料
export const fetchBuilding = createAsyncThunk(
  'building/fetchBuilding',
  async (buildingId, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.getWithAuth(`/setting/building/${buildingId}`, null, token);
      return data;
    } catch (err) {
      console.error('fetch building error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);

// 取得大樓清單列表
export const fetchBuildingList = createAsyncThunk(
  'building/fetchBuildingList',
  async ({buildingId}, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.getWithAuth('/setting/building', {buildingId: buildingId}, token);
      return data;
    } catch (err) {
      console.error('fetch building list error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);

// 取得有效的大樓名稱選單
export const fetchBuildingSelection = createAsyncThunk(
  'building/fetchBuildingSelection',
  async (_, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.getWithAuth('/selection/building', null, token);
      return data;
    } catch (err) {
      console.error('fetch building selection error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);

// 修改大樓預設有效梯控申請天數
export const updateDefaultPeriod = createAsyncThunk(
  'building/updateDefaultPeriod',
  async ({buildingId, defaultPeriod}, {getState, rejectWithValue}) => {
    try {
      const token = getState().auth.token;
      const data = await BaseAPI.putWithAuth('/setting/building/applyDays', {buildingId: buildingId, defaultPeriod: defaultPeriod}, token);
      return data;
    } catch (err) {
      console.error('update building default period error', err.response.data);
      return rejectWithValue(err.response.data);
    }
  },
);
